<template>
	<div class="project-list-row"
		v-on:click.stop="onClickSelectProject"
		v-bind:class="classProjectListRow"
	>
		<div class="project-list-row-inner" v-bind:style="styleInner">
			<div class="project-list-row-content d-flex pa-2">
				<div style="width: 100%;">
					<div class="name">{{ this.item.name }}</div>
					<Classes
						:items=this.item.classes
						:max_width=278
						:all_show=false
						:is_show_icon=true
					/>
					<div class="schedules">
						{{ displaySchedule(this.item.schedules[0]) }}
						<template  v-if="this.item.schedules.length > 1">
							&nbsp;他{{this.item.schedules.length - 1}}件
						</template>
					</div>
				</div>
			</div>
			
			<div class="project-list-row-action d-flex" v-if="!isSelectMode">
				<v-btn fab flat class="btn-slide" v-on:click.stop="toggleSlideLeft"><v-icon>more_horiz</v-icon></v-btn>
			</div>
			<div class="member-list-row-action d-flex" v-else-if="isSelected">
				<template class="btn-slide" v-on:click.stop="toggleSlideLeft"><v-icon>check</v-icon></template>
			</div>
			<div class="member-list-row-action d-flex" v-else>
				<template class="btn-slide" v-on:click.stop="toggleSlideLeft"></template>
			</div>
			
			<div class="project-list-row-right d-flex">
				<template v-if="$store.getters['chart/isEditable']">
					<v-btn depressed color="warning" class="btn-edit" v-on:click.stop="onShowProjectInfo">編集</v-btn>
				</template>
				<template v-else>
					<v-btn depressed color="info" class="btn-show" v-on:click.stop="onShowProjectInfo">参照</v-btn>
				</template>
			</div>
		</div>
	</div>
</template>
<script>
import Classes from './Classes';
import {SLIDE, LIST_MODE} from '../classes/Const';

export default {
	name: 'RightPaneProjectListRow',
	props: [
		'item',
		'isSelected',
		'mode',
		'watchSlide'
	],
	components: {
		Classes,
	},
	data: function() {
		return {
			slide_status: SLIDE.STATUS.CENTER,
		};
	},
	methods: {
		toggleSlide: function(direction) {
			if (this.slide_status === direction)
				this.slide_status = SLIDE.STATUS.CENTER;
			else {
				this.slide_status = direction;
				this.$emit('project-list-row-slide', {target: this.item, status: this.slide_status});
			}
		},
		toggleSlideLeft: function() {
			this.toggleSlide(SLIDE.STATUS.LEFT);
		},
		onClickSelectProject: function() {
			this.$emit('project-selected', this.item.code);
		},
		onShowProjectInfo: function() {
			let project = this.$store.getters.project(this.item.code);
			this.$emit("show-project-info", project);
		},
		onProjectListRowSlide: function(e) {
			this.watchSlide = {
				type: 'slide',
				target: e.target,
				status: e.status,
			};
		},
		displaySchedule: function(schedule) {
			let text = '';
			
			if (typeof schedule == 'undefined')
				return text;

			if (schedule.all_day) {
				text += schedule.begin.strftimeDCL('%m月%d日');
				text += " ～ ";
				text += schedule.end.strftimeDCL('%m月%d日');
			} else {
				if (schedule.isSingleDay) {
					text = schedule.begin.strftimeDCL('%m月%d日 %H:%M') + "～" + schedule.end.strftimeDCL('%H:%M')
				} else {
					text = schedule.begin.strftimeDCL('%m月%d日 %H:%M') + "～" + schedule.end.strftimeDCL('%H:%M %m月%d日')
				}
			}
			return text;
		},
	},
	computed: {
		styleInner: function() {
			let left = 0;
			if (this.slide_status == SLIDE.STATUS.LEFT) {
				left =  -60;
			}
			return {
				left: left + 'px',
				transition: 'all .3s ease-in',
			};
		},
		isSelectMode: function(){
			if (this.mode == LIST_MODE.SELECT){
				return true;
			} else {
				return false;
			}			
		},
		classProjectListRow: function(){
			let classes = new Array();
			if (this.mode == LIST_MODE.SELECT){
				classes.push("selectable");
			}
			
			return classes
		}
		
	},
	watch: {
		watchSlide: function(value) {
			if (value.type === 'slide' && value.target === this.item)
				return;
			if (this.slide_status !== SLIDE.STATUS.CENTER)
				this.slide_status = SLIDE.STATUS.CENTER;
		},
	},
};
</script>
<style>
	.project-list-row {
		position: relative;
		flex: 1 1 auto;
		overflow: hidden;
		width: 100%;
		min-height: 65px;
		background-color: #fefefe;
		border-bottom: solid 1px #a9a9a9;
	}
	.project-list-row-inner {
		display: flex;
		position: relative;
		width: 470px;
	}
	.project-list-row-content {
		padding: .25em;
		width: 294px;
	}
	.project-list-row-content .name {
		height: 1.5em;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		width: 100%
	}
	.project-list-row-action {
		position: relative;
	}
	.project-list-row-action .btn-slide {
		min-width: 36px !important;
	}
	.project-list-row-right div {
		width: 16px;
	}
	.project-list-row .name {
		font-size: 18px;
	}
</style>
<style scoped>
	.project-list-row.selectable{
		cursor: pointer;
	}
	.project-list-row.selectable:hover{
		background-color: #EFEFEF;
	}
	.v-btn {
		margin: 0;
		padding: 0;
		min-width: 60px;
		height: 100%;
		border-radius: 0;
		font-size: .75em;
	}
	.alert-icon {
		position: absolute;
		right: 15px;
		top: 0;
		opacity: .6;
		cursor: pointer;
		pointer-events: none;
		color: darkorange;
	}
	.member-list-row-action{
		min-width:60px;
	}
</style>
